// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"885":"345265a4","921":"833afec5"}[chunkId] + ".chunk.js";
};